import { mapState, mapMutations } from 'vuex';

import Axios from '@/helpers/axios';

const mixin = {
  computed: mapState([
    'client',
  ]),
  methods: {
    ...mapMutations([
      'clearUtk',
    ]),
    gotoReturnURL() {
      if (this.$route.query.r) {
        // 如果有 r 就導回 r
        window.location = decodeURIComponent(this.$route.query.r);
      } else if (this.$route.query.rv) {
        // 如果有 rv 就導 rv
        this.$router.push({
          name: this.$route.query.rv,
          params: {
            brand: this.$route.params.brand,
          },
        });
      } else {
        // 如果沒 r 導回會員中心
        this.$router.push({
          name: 'Index',
          params: {
            brand: this.$route.params.brand,
          },
        });
      }
    },
    appendURLQurey(data) {
      return Object.assign(data, this.$route.query);
    },
    logout() {
      const data = {
        ...this.$route.query,
        lang: this.$i18n.locale,
        p: this.client.phoneType,
        brand_id: this.$route.params.brand,
        dtk: this.client.dtk,
      };

      Axios({
        method: 'post',
        url: '/Login_w/logout',
        data,
      })
        .then((response) => {
          if (response.data.code === 500) {
            this.$gtm.trackEvent({
              event: '登出',
            });
            this.clearUtk();
            Axios.defaults.headers.common.Authorization = '';
            this.$router.push({
              name: 'Entry',
              query: {
                ...this.$route.query,
              },
            });
          }
        });
    },
  },
};

export default mixin;
